<template>
    <div id="data-list-list-view">
        <vs-tabs v-model="tabIndex" class="padTop20">
            <vs-tab :label="item.label" v-for="item in vsTabsList" :key="item.id">
                <div class="flex filterWrap marTop18">
                    <gc-cmp-vs-input v-model="filterText" class="filterInput"
                                     placeholder="请输入名称" @input="getTableData(1)"/>
                    <vs-button v-if="tabIndex == 1&&filtering('warehouse:son:add')" @click="addNewWarehouse(false)">新增</vs-button>
                </div>
                <gc-cmp-vs-table :data="tableData" pagination :pager="pager"
                                 @changePage="changePage">
                    <template slot="thead">
                        <vs-th v-for="(column, index) in columns[tabIndex]" :key="index">
                            {{column.name}}
                        </vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <tbody>
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td v-for="(item, idx) in columns[tabIndex]" :key="item.code">
                                <div v-if="item.code == 'index'">{{ indextr+1 }}</div>

                                <!-- 操作 -->
                                <template v-else-if="(idx == columns[tabIndex].length -1)">
                                    <!-- <vs-button v-if="tabIndex == 1" color="primary" type="flat" size="small" @click.stop="addNewWarehouse(true, tr, true)">添加仓位</vs-button> -->
                                    <feather-icon v-if="filtering('warehouse:general:update')&&filtering('warehouse:son:update')" icon="EditIcon" svgClasses="w-5 h-5 stroke-current" class="text-primary"
                                                  @click.stop="addNewWarehouse(true, tr, false)" />
                                    <feather-icon v-if="tabIndex == 1&&filtering('warehouse:son:delete')" icon="TrashIcon" svgClasses="w-5 h-5 stroke-current" class="ml-2 text-danger"
                                                  @click.stop="deleteWarehouse(tr)" />
                                </template>
                                <template v-else>{{ tr[item.code ]}}</template>
                            </vs-td>
                        </vs-tr>
                        </tbody>
                    </template>
                </gc-cmp-vs-table>
                <!-- <vs-pagination
                 v-if="tabIndex == 1"
                 :total="Math.ceil(pager.total/pager.size)"
                 v-model="pager.page"
                 :max-items="pager.size">
             </vs-pagination>  -->
                <gc-vs-pagination
                        :pager="pager"
                        @handleSizeChange="handleSizeChange"
                        @handleCurrentChange="handleCurrentChange"
                ></gc-vs-pagination>
            </vs-tab>
        </vs-tabs>
    </div>
</template>

<script>
    import GcCmpVsTable from "@/group-cloud/components/vsTable";
    import GcCmpVsInput from "@/group-cloud/components/vsInput";
    import {
        WmsWarehouseApi,
        Mod_Warehouse_Types_Options
    } from "@/modules/server-api/wms-manage/warehouse";
    export default {
        data(){
            return{
                tabIndex:this.$route.params.tabIndex?this.$route.params.tabIndex:0,
                filterText:"",
                vsTabsList:[
                    Mod_Warehouse_Types_Options[1],
                    Mod_Warehouse_Types_Options[2]
                ],//tab标签页
                warehouseList: Mod_Warehouse_Types_Options,//仓库字典级
                columns:[
                    [{
                        code: 'index',
                        name: "序号"
                    },{
                        code: "wsCode",
                        name:"主仓编号"
                    },{
                        code: "wsName",
                        name:"仓库名称"
                    },
                        {
                            code: "contact",
                            name:"负责人"
                        },
                        {
                            code: "phone",
                            name:"联系方式"
                        },
                        {
                            code: "address",
                            name: "仓库位置"
                        },
                        {
                            code: "bodyName",
                            name: "主体名称"
                        },
                        {
                            code: 'option',
                            name: '操作'
                        }
                    ],
                    [   {
                        code: "index",
                        name:"序号"
                    },
                        {
                            code: "relWsName",
                            name:"上级节点"
                        },{
                        code: "wsCode",
                        name:"分仓编号"
                    },
                        {
                            code: "bodyName",
                            name: "主体名称"
                        },
                        {
                            code: "wsName",
                            name:"仓库名称"
                        },
                        {
                            code: 'locNames',
                            name: "仓位"
                        },
                        {
                            code: 'option',
                            name: '操作'
                        }
                    ]
                ],
                tableData:[],
                totalCount:0,
                pager: {
                    page: 1,
                    size: 20,
                    total:20,
                }
            }
        },
        mounted(){
            let that = this;
            that.getTableData();
        },
        methods:{
            //查询主仓/分仓
            async getTableData(page){
                this.$vs.loading();
                // if (page) this.pager.page = page;
                console.log('this.pager.page',page,this.pager.page)
                let pageNo = page || this.pager.page
                let resp = await WmsWarehouseApi.getWarehouseList({
                    "pageNo": pageNo,
                    "pageSize": this.pager.size,
                    data:{
                        suggest:this.filterText,
                        type: this.vsTabsList[this.tabIndex].id//仓位类型
                    }
                });
                this.pager.total = resp.result.totalCount
                this.tableData = resp.result.list;
                this.$vs.loading.close();
                console.log(' this.tableData', this.tableData)
            },
            //分页
            // async changePage(payload) {
            //   this.pager.page = payload.page || 1;
            //   return await this.getTableData();
            // },
            //新增、编辑
            addNewWarehouse(isEdit, row, isAddLoc){
                //添加仓位
                if(isAddLoc){
                    //添加的仓库类型
                    sessionStorage.setItem("warehouseType", this.warehouseList[3].id);
                    sessionStorage.setItem("tabIndex", this.tabIndex);

                }else{
                    //添加的仓库类型
                    sessionStorage.setItem("warehouseType", this.vsTabsList[this.tabIndex].id);

                }
                if(isEdit){
                    sessionStorage.setItem("warehouseInfo", JSON.stringify(row));
                }else{
                    sessionStorage.removeItem("warehouseInfo");
                }
                sessionStorage.setItem("tabIndex", this.tabIndex);
                this.$router.push({path: '/modules/wms/manage/warehouse/edit'});
                // this.$router.push({name:'Wms-Manage-Warehouse-Edit',params:{tabIndex:index}}).catch(() => {})
            },
            //删除
            deleteWarehouse(row){
                this.$vs.dialog({
                    type: 'confirm',
                    title:`操作提示`,
                    text: `您确认删除${row.wsName}吗？`,
                    acceptText: '确认',
                    cancelText: '取消',
                    accept: () => {this.doDeleteGoods(row)}
                })
            },
            async doDeleteGoods(row){
                let res = await WmsWarehouseApi.deleteWarehouse({"id":row.wsId});
                if(res.succ == 1){
                    this.$notifySuccess('删除成功');
                    this.getTableData();
                }else{
                    this.$notifyError(res.error);
                }
            },
            //切换页签
            async changePage(payload) {
                this.pager.page = payload.page || 1;
                return await this.getTableData();
            },
            //更改每页条数
            handleSizeChange(val){
                this.pager.size = val;
                this.getTableData();
            },
            handleCurrentChange(val){
                this.pager.page = val;
                this.getTableData();
            }
        },
        components: {
            GcCmpVsTable,GcCmpVsInput
        },
        watch:{
            tabIndex(index){
                this.filterText = "";
                this.pager.page = 1;
                this.tableData = [];
                this.errorTableData = [];
                this.getTableData();
            }
            // ,
            // //分页
            // "pager.page"(){
            //   this.getTableData();
            // }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/modules/commodity-sys/commodity.scss';
</style>
